import { createModel } from 'xstate/lib/model';

import { KybDocumentType } from '__generated__/GQL';
import baseEvents from 'common/bento/config/baseEvents';

import { CapitalDepositProofOfFundsQuery } from '../graphql/queries/CapitalDepositProofOfFunds.gql';

type ProofOfFundsModuleData = {
  proofOfFundsData: CapitalDepositProofOfFundsQuery;
};

export type KybDocumentFile = {
  url: string;
  firebaseBucket: string;
  firebaseRef: string;
  type: KybDocumentType;
};

export enum ProofOfFundsDocumentType {
  bankStatement = 'bankStatement',
  loanCertificate = 'loanCertificate',
  paySlip = 'paySlip',
}

export type Context = {
  documentFile: KybDocumentFile | null;

  getModuleData: () => ProofOfFundsModuleData;

  selectedOption: ProofOfFundsDocumentType | null;
};

const initialContext: Context = {
  documentFile: null,

  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },

  selectedOption: null,
};

const model = createModel(
  initialContext,

  {
    events: {
      ...baseEvents,
      DELETE_DOCUMENT: (data: string) => ({ data }),
      SELECT_DOCUMENT_TYPE: (option: ProofOfFundsDocumentType) => ({
        option,
      }),
      SUBMIT_DOCUMENT_FILE: (data: KybDocumentFile) => ({ data }),
    },
  },
);

export default model;

export type Model = typeof model;
